module.exports = __webpack_public_path__ + "static/media/no_profile2.02d8bd56.png";